import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setGameSettings } from "../Redux/gameSettingsSlice";
import { generalGetFunction, generalPostFunction } from "./globalFunctions";
import { setAllPlayers } from "../Redux/allPlayersSlice";
import { gamePorts } from "./globalMetaData";

function GlobalCalls() {
	const dispatch = useDispatch();
	const account = JSON.parse(localStorage.getItem("account"));
	const gameSettingsRefresh = useSelector((state) => state.gameSettings.gameSettingsRefresh);
	const gameName = useSelector((state) => state.gameSettings.gameName);
	const allPlayersRefresh = useSelector((state) => state.allPlayers.allPlayersRefresh);

	useEffect(() => {
		const getAllSettings = async () => {
			const selectedGame = gameName;
			const port = gamePorts[selectedGame];

			try {
				const response = await generalGetFunction(`/getallsettings`, port);
				if (response.status == 200) {
					dispatch(setGameSettings(response.data));
				}
			} catch (err) {
				console.log(err);
			}
		};
		getAllSettings();
	}, [gameName, gameSettingsRefresh]);

	useEffect(() => {
		const getAllPlayers = async () => {
			try {
				const response = await generalGetFunction(`/getallusers?username=${account?.username}&level=${account?.level}`, "3040");
				dispatch(setAllPlayers(response));
			} catch (err) {
				console.log(err);
			}
		};
		getAllPlayers();
	}, [allPlayersRefresh]);

	return null;
}

export default GlobalCalls;
